<template>
  <form-field-select
    label="Associated Lead"
    :value="value"
    :validation-errors="validationErrors"
    @input="handleInput"
  >
    <option :value="null">No lead</option>
    <option
      v-for="record in records"
      :key="record.id"
      :value="record.id"
    >{{ $utils.getRecordAddressLabel(record) }}</option>
  </form-field-select>
</template>

<script>
export default {
  name: "FormFieldSelectLeads",
  props: {
    value: {
      type: Number,
    },
    records: {
      type: Array,
      required: true
    },
    validationErrors: {
      type: [String, Array, undefined],
    },
  },
  data() {
    return {
      selectedRecordId: null
    }
  },
  watch: {
    records(newValue, oldValue) {
      if (oldValue.length === 0 && newValue.length !== 0) {
        this.selectedRecordId = newValue[0].id;
        this.handleInput(this.selectedRecordId);
      }
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
      this.$emit('change', value);
      this.$emit('selected', value);
    },
  }
}
</script>
